import useMatriculasList from "./useMatriculasList";
import useMatriculaForm from "./useMatriculaForm";
import useMatriculasOptions from "./useMatriculasOptions";
import useContratoInscripcion from "./useContratoInscripcion";

export default function useMatriculasLogic() {
  const list = useMatriculasList();
  const options = useMatriculasOptions();
  const contrato = useContratoInscripcion();

  const form = useMatriculaForm({
    onCreated: (nueva) => list.upsertMatricula(nueva),
    onUpdated: (actualizada) => {
      list.upsertMatricula(actualizada);
      if (list.seleccionado?.id === actualizada.id) list.setSeleccionado(actualizada);
    },
    onDeleted: (borrada) => {
      list.removeMatricula(borrada.id);
      if (list.seleccionado?.id === borrada.id) list.setSeleccionado(null);
    },
  });

  return {
    ...list,
    ...options,
    form,
    contrato,
  };
}
